module.exports = __webpack_public_path__ + "static/media/washington-dc-79.94c72a75.jpg";